import { t } from 'ttag';
import classNames from 'classnames';

import { Stars } from '@ui/Stars';

import s from './SellerRatingWithReviewsCount.sss';

type TProps = {
  overallRating: string;
  reviewsCount: number;
  reviewsCountByPeriod: number;
  userName?: string;
  className?: string;
};

export const SellerRatingWithReviewsCount: React.FC<TProps> = (
  {
    userName,
    overallRating,
    reviewsCount,
    reviewsCountByPeriod,
    className,
  },
) => (
  <div className={classNames(s.root, className)}>
    <div className={s.averageRating}>{overallRating}</div>
    <Stars
      readOnly={true}
      value={Number(overallRating)}
      width="40"
      height="40"
      gap={16}
    />
    <div className={s.text}>{t`${reviewsCountByPeriod} оцінки за рік`}</div>
    <div className={s.text}>{t`${reviewsCount} оцінок за весь час`}</div>
    <a href={`/member/${userName}/reviews?t=s`} className={s.reviews}>
      {t`Відгуки ${reviewsCount}`}
    </a>
  </div>
);
